<template>
  <header class="n-header">
    <div class="n-header__wrap">
      <h1 class="logo"><img src="https://www.pai2345.com/static/web/res/images/logo-3.png" alt="千途导摄" /></h1>
      <transition name="nav-hor" out-in>
        <nav class="nav-hor" v-if="showNav">
          <ul>
            <li>
              <a :href="menuUrl.home"><span>主页</span><span>HOME</span></a>
            </li>
            <li class="active">
              <a :href="menuUrl.buy"><span>购图</span><span>BUY</span></a>
            </li>
            <li>
              <a :href="menuUrl.webps"><span>修图</span><span>RETOUCH</span></a>
            </li>
            <li>
              <a :href="menuUrl.match"><span>比赛</span><span>MATCH</span></a>
            </li>
            <li>
              <a href="#"><span>发布</span><span>EXPLORE</span></a>
              <div class="nav-hor-sub">
                <ul>
                  <li>
                    <a :href="menuUrl.fworkAddShoot">发布摄影作品<span></span></a>
                  </li>
                  <li>
                    <a :href="menuUrl.fworkAddTravels">发布游记<span></span></a>
                  </li>
                  <li>
                    <a :href="menuUrl.fworkIndex">已发布管理<span></span></a>
                  </li>
                  <li>
                    <a :href="menuUrl.fworkDraft">未完成任务<span></span></a>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <a :href="menuUrl.edu"><span>云课堂</span><span>EDUCATION</span></a>
            </li>
            <li>
              <a :href="menuUrl.wuliu"><span>五六公社</span><span>WULIU</span></a>
            </li>
          </ul>
        </nav>
        <nav class="nav-vertical" v-else>
          <div class="n-nav-menu">
            <a :href="menuUrl.home" class="home">
              <span>首页</span>
              <span>HOME</span>
            </a>
            <ul>
              <li>
                <a :href="menuUrl.buy" class="item">购图<span></span></a>
              </li>
              <li>
                <a :href="menuUrl.webps" class="item">修图<span></span></a>
              </li>
              <li>
                <a :href="menuUrl.match" class="item">比赛<span></span></a>
              </li>
              <li>
                <a href="" class="item">发布<span></span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#iconright2"></use>
                  </svg>
                </a>
                <div>
                  <ul>
                    <li>
                      <a :href="menuUrl.fworkAddShoot">发布摄影作品<span></span></a>
                    </li>
                    <li>
                      <a :href="menuUrl.fworkAddTravels">发布游记<span></span></a>
                    </li>
                    <li>
                      <a :href="menuUrl.fworkIndex">已发布管理<span></span></a>
                    </li>
                    <li>
                      <a :href="menuUrl.fworkDraft">未完成任务<span></span></a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <a :href="menuUrl.edu" class="item">云课堂<span></span></a>
              </li>
              <li>
                <a :href="menuUrl.wuliu" class="item">五六公社<span></span></a>
              </li>
            </ul>
          </div>
        </nav>
      </transition>

      <div class="indexsearch-wrap" v-show="!showNav">
        <div class="search-inner">
          <n-search
                  ref="nhsearch"
                  v-model="keyword"
                  placeholder="搜索图片，各个关键字用空格隔开，按回车搜索"
                  @by-keyword="handleSearchKeyword"
                  @by-image="handleSearchImage"
                  @by-error="handleSearchError"
          ></n-search>
        </div>
      </div>

      <ul class="user-logwrap">
        <div class="ncard-wrap" v-if="isLogin">
          <div class="user-wrap">
            <img class="avatar" :src="userInfo.avatar" alt="" />
            <span> {{ userInfo.nickname }}</span>
          </div>
          <div class="user-detail__wrap">
            <div class="user-info">
              <img class="avatar-big" :src="userInfo.avatar" alt="用户头像" />
              <div class="username">
                <span>{{ userInfo.nickname }}</span>
                <div class="icon-wrap">
                  <span><i class="nicon nicon-cion"></i>{{ userInfo.coin }}</span>
                  <span><i class="nicon nicon-bean"></i>{{ userInfo.ticket }}</span>
                </div>
              </div>
              <div class="btn-wrap">
                <a class="btn btn-logoout" @click="handleLogout">
                  <i class="nicon nicon-logoout"></i>退出
                </a>
                <a class="btn btn-pay" :href="menuUrl.combo">充值</a>
              </div>
            </div>
            <div class="nav-tool">
              <div class="user-link">
                <a class="user-link-item" :href="menuUrl.memberOrder">
                  <p><i class="nicon-myorder"></i></p>
                  <p>云图库</p>
                </a>
                <a class="user-link-item" :href="menuUrl.memberLetter">
                  <p>
                    <i class="nicon-mymessage"
                      ><span class="layui-badge"></span
                    ></i>
                  </p>
                  <p>站内信</p>
                </a>
                <a class="user-link-item" :href="menuUrl.proxyOrder">
                  <p><i class="icon-autoJoin"></i></p>
                  <p>自动投稿</p>
                </a>
                <a class="user-link-item" :href="menuUrl.myLikes">
                  <p><i class="el-icon-folder-opened" style="font-size:25px;margin-bottom:5px;color:#ec7a5d"></i></p>
                  <p>收藏夹</p>
                </a>
                <a class="user-link-item" :href="menuUrl.memberGallery">
                  <p><i class="nicon-mygallery"></i></p>
                  <p>我的云盘</p>
                </a>
                <a class="user-link-item" :href="menuUrl.memberVip">
                  <p><i class="nicon-myvip"></i></p>
                  <p>我的贵族</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="login-btn" v-else @click="handleLogin">登录 / 注册</div>
      </ul>
    </div>
    <n-login :show="show"></n-login>
  </header>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      showNav: true,
      menuUrl: {
        home: '//www.pai2345.com',
        buy: '//imgstore.pai2345.com/',
        webps: '//www.pai2345.com/web/ps',
        match: '//match.pai2345.com',
        edu: '//edu.pai2345.com',
        wuliu: '//www.pai2345.com/qtclub_web/',
        fworkAddShoot: '//www.pai2345.com/web/Findworks/addShoot',
        fworkAddTravels: '//www.pai2345.com/web/Findworks/addTravels',
        fworkIndex: '//www.pai2345.com/web/Findworks/index',
        fworkDraft: '//www.pai2345.com/web/Findworks/draft',
        memberGallery: '//www.pai2345.com/web/member/index#/gallery',
        memberVip: '//www.pai2345.com/web/member/index#/vip',
        memberLetter: '//www.pai2345.com/web/member/index#/letter',
        memberOrder: '//www.pai2345.com/web/member/index#/order',
        combo: '//www.pai2345.com/web/combo/index',
        proxyOrder:'//www.pai2345.com/web/member/index#/proxy-order',
        myLikes: '//imgstore.pai2345.com/web/#/usercenter/likes'
      },
      isLogin: false,
      userInfo: {
        avatar: '',
        mobile: 0,
        username: '',
        nickname: '',
        user_id: 0,
        ticket: 0,
        coin: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["getKeyword", "getSearchImage"]),
    keyword: {
      set(val) {
        this.setKeyword(val);
      },
      get() {
        return this.getKeyword;
      },
    },
    searchImage: {
      set(val) {
        this.setSearchImage(val);
      },
      get() {
        return this.getSearchImage;
      },
    },
  },
  created() {
    var _self = this;
    this.$axios.api.getUserInfo(function (res) {
      if (res.code == 1) {
        _self.isLogin = true;
        _self.userInfo = res.data.userinfo;
      } else {
        _self.isLogin = false;
      }
    })
  },
  mounted() {
    var _self = this;
    window.addEventListener("scroll", (e) => {
      if (_self.hideHeaderScroll) {
        return;
      }
      let top = e.target.documentElement.scrollTop;
      if (top > 70) {
        this.showNav = false;
      } else {
        this.showNav = true;
      }
    });
  },
  methods: {
    ...mapMutations({
      setKeyword: "keyword",
      setSearchImage: "searchImage"
    }),
    handleScroll(e) {
      let top = e.target.documentElement.scrollTop;
      if (top > 70) {
        this.showNav = false;
      } else {
        this.showNav = true;
      }
    },
    //passport登录
    handleLogin() {
      passportLogin.login();
    },
    //passport登出
    handleLogout() {
      passportLogin.passportLogout();
      this.$axios.api.logout(function (res) {
        if (res.code == 1) {
          window.location.reload();
        }
      })
    },
    //搜索数据
    search() {
      this.$refs.nhsearch.hideUpload(true);
      var gtiem = new Date();
      this.$router.push({path: '/search', query: {time: gtiem.getTime()}});
    },
    //搜索框错误提示
    handleSearchError(msg) {
      this.$message.error(msg);
    },
    //搜索框文字搜索
    handleSearchKeyword(keyword) {
      this.search();
    },
    //搜索框图片搜索
    handleSearchImage(image) {
      this.searchImage = image;
      this.search();
    },
  },
  model: {
    prop: "input",
    event: "input",
  },
  props: {
    input: "",
    show: false,
    hideHeaderScroll: false
  },
};
</script>

<style lang="scss" scoped>
.n-header {
  width: 100%;
  height: 70px;
  padding: 0 72px;
  position: fixed;
  color: #fff;
  top: 0;
  left: 0;
  background-color: $bgColor;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  .n-header__wrap {
    width: 1340px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    margin-right: 10px;
    > img {
      width: 130px;
    }
  }
  li {
    &:hover > a {
      color: $primaryColor !important;
    }
  }
  li.active{
    background: #ec7a5d;
  }
  nav {
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: -100px;
  }
  .n-nav-menu {
    min-width: 120px;
    max-width: 120px;
    height: 70px;
    flex-shrink: 0;
    text-align: center;
    color: #fff;
    background-color: $primaryColor;
    &:hover > ul {
      display: block;
    }
    .home {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #fff;
      > span {
        cursor: pointer;
        height: 20px;
        line-height: 20px;
        font-size: 20px;
        &:nth-child(2) {
          font-size: 12px;
          margin-top: 6px;
        }
      }
    }
    > ul {
      width: 100%;
      background-color: #fff;
      box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      line-height: 20px;
      padding: 0 31px;
      display: none;
      > li {
        display: inline-block;
        cursor: pointer;
        font-size: 18px;
        line-height: 40px;
        position: relative;
        width: 100%;
        height: 40px;
        &:hover div {
          display: block;
          position: absolute;
        }
        > a {
          color: #333333;
          display: inline-block;
          width: 100%;
          height: 100%;
          vertical-align: middle;
          text-align: justify;
          position: relative;
          > span {
            display: inline-block;
            padding-left: 100%;
          }
          svg {
            position: absolute;
            top: 12px;
            left: 62px;
          }
        }
        > div {
          display: none;
          width: 146px;
          left: 140%;
          top: 0px;
          ul {
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
            background-color: #fff;
            padding: 4px 2px;
            margin-left: 16px;
          }
        }
      }
    }
  }
  .user-logwrap {
    cursor: pointer;

    .login-btn {
      width: 140px;
      text-align: center;
    }
    .ncard-wrap {
      position: relative;
      height: 70px;
      line-height: 70px;
    }
    .ncard-wrap:hover .user-detail__wrap {
      display: block;
    }
    .user-wrap {
      width: 140px;
      height: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      vertical-align: middle;
      .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
  .user-detail__wrap {
    display: none;
    height: 220px;
    width: 420px;
    padding: 18px 20px 12px;
    position: absolute;
    z-index: 22;
    top: 70px;
    right: -24px;
    box-shadow: 0 2px 2px rgba(0,0,0,.1);
    cursor: default;
    background: url('https://www.pai2345.com/static/web/res/images/user-box.png') no-repeat;
    background-size: 100% 100%;
    .user-info {
      display: flex;
      align-items: center;
      width: 100%;
      // height: 110px;
      // border-bottom: 1px solid #eee;
    }
    .avatar-big {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-right: 8px;
    }
    .username {
      height: 100%;
      width: 210px;
      padding: 22px 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #333;
      display: flex;
      flex-direction: column;
      line-height: 14px;
      > span {
        margin-bottom: 30px;
        font-size: 18px;
      }
      .icon-wrap {
        display: flex;
        width: 100%;
        // background-color: red;
        > span {
          display: inline-block;
          width: 90px;
        }
      }
    }
    .btn-wrap {
      width: 80px;
      padding: 16px 8px;
      height: 100%;
      margin-left: 10px;
      line-height: 30px;
      .btn-logoout {
        color: #2f8cff;
        font-size: 14px;
        cursor: pointer;
      }
      .btn {
        text-align: center;
      }
      .btn-pay {
        margin-top: 12px;
        display: inline-block;
        background-color: #ec7a5d;
        color: #fff;
        width: 60px;
        border-radius: 6px;
        font-size: 14px;
      }
    }
    .nav-tool {
      padding: 20px 0 0;
      font-size: 14px;
      line-height: 20px;
      width: 100%;
      height: 100px;
      text-align: center;
      .user-link {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
      }
      .user-link a:hover {
        color: #ec7a5d;
      }
    }
  }
  .nicon-bean {
    width: 24px;
    height: 20px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/0930/icon-ticket.png)
      no-repeat;
    vertical-align: middle;
    margin: -4px 6px 0 0;
  }
  .nicon-cion {
    width: 24px;
    height: 20px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/icon-1.png)
      no-repeat;
    background-position: 0 -124px;
    vertical-align: middle;
    margin: -4px 6px 0 0;
  }
  .nicon-logoout {
    width: 18px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
    background: url(https://www.pai2345.com/static/web/res/images/icon-2.png)
      no-repeat;
    background-position: -60px -54px;
    margin-right: 5px;
  }
  .nicon-myorder {
    width: 25px;
    height: 25px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/icon-2.png)
      no-repeat;
    background-position: -54px 0;
  }

  .nicon-mymessage {
    width: 25px;
    height: 25px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/icon-2.png)
      no-repeat;
    background-position: -27px 0;
    position: relative;
  }
  .icon-autoJoin {
    width: 25px;
    height: 25px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/210412/icon-1.png)
      no-repeat center;
    position: relative;
  }
  .nicon-mygallery {
    width: 25px;
    height: 25px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/icon-2.png)
      no-repeat;
    background-position: 0 0;
    position: relative;
  }
  .nicon-myvip {
    width: 25px;
    height: 25px;
    display: inline-block;
    background: url(https://www.pai2345.com/static/web/res/images/icon-2.png)
      no-repeat;
    background-position: -81px 0;
    position: relative;
  }
  .indexsearch-wrap {
    width: 644px;
    box-sizing: border-box;
    z-index: 999;
    border: none;
    display: flex;
    flex-direction: column;
    transition: all 0.5s linear;
    margin-left: -100px;
  }
  .indexsearch-wrap .search-inner {
    height: 38px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
  }
  .indexsearch-wrap .search-inner > input {
    width: 100%;
    height: 100%;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    padding: 0 26px;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    border: 1px solid #a5a5a5;
  }
  .indexsearch-wrap .search-inner > input:focus {
    border: 1px solid #ec7a5d;
  }
  .hotkey-wrap {
    width: 100%;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    padding: 4px 26px;
  }
  .hotkey-wrap > span {
    margin-right: 6px;
    cursor: pointer;
  }
  .hotkey-wrap > span:hover {
    color: #ec7a5d;
  }
  .icon-search {
    background-image: url(/icons/search-icon.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
    position: absolute;
    z-index: 2;
    top: 7px;
    right: 25px;
  }

  .nav-hor {
    flex: 1;
    margin-left: 20px;
    > ul {
      display: flex;
      align-items: center;
      width: 900px;
      height: 70px;
      line-height: 70px;
      font-size: 20px;
      li {
        width: 120px;
        height: 100%;
        text-align: center;
        margin-right: 10px;
      }
      a {
        display: flex;
        width: 100%;
        height: 100%;
        color: #fff;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        line-height: 100%;
        > span:nth-child(2) {
          font-size: 12px;
          margin-top: 5px;
        }
      }
      a:hover {
        color: #fff !important;
        background-color: $primaryColor;
      }
      .nav-hor-sub{
        display:none;
        background-color:#fff;
        box-shadow:0 0 10px rgba(0,0,0,.2);
        font-size: 14px;
        li{
          padding:10px 0;
        }
        a{
          color:#333!important;
        }
        a:hover{
          background-color:#fff!important;
          color:#ef7f48!important;
        }
      }
      li:hover{
        .nav-hor-sub{
          display: block;
        }
      }
    }
  }
}
.nav-hor-enter-active,
.nav-hor-leave-active {
  transition: all 0.2s linear;
}
.nav-hor-enter, .nav-hor-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(0);
}

.input_suffix {
  display: inline-block;
  width: 80px;
  height: 30px;
  font-size: 30px;
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translate(0, -50%);
  z-index: 100;
  cursor: pointer;
  > svg {
    color: $primaryColor;
    vertical-align: top;
  }
  .split-line {
    width: 2px;
    height: 30px;
    background-color: #888;
    display: inline-block;
    margin: 0 8px;
  }
}

</style>